import { useEffect } from "react";

// The bag slip, sized for a 58 mm receipt printer. It carries only the order
// number, never the medicines or the customer's details.
export default function Slip({ orderId }: { orderId: string }) {
  useEffect(() => {
    const t = setTimeout(() => window.print(), 300);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="mx-auto w-[58mm] text-center font-mono">
      <style>{"@page { size: 58mm auto; margin: 2mm; }"}</style>
      <div className="text-sm">SAVON</div>
      <div className="my-2 text-3xl font-bold">{orderId}</div>
      <div className="text-xs">Sealed by the pharmacy. Do not open.</div>
      <button className="no-print mt-6 text-sm underline" onClick={() => history.back()}>
        Back
      </button>
    </div>
  );
}
